/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 证书
 */
import dayjs from 'dayjs';
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class CertController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.cert_list,
      paginationParams: {
        currentKey: 'pageNum',
        pageSizeKey: 'pageSize',
        response: {
          valueGetter: this.valueGetter,
        },
      },
    });
  }

  valueGetter = async (response, AjaxConfig) => {
    lodash.map(lodash.get(response, 'data'), (item) =>
      lodash.assign(item, {
        ntitle: item.certName,
        nsectiononeId: 'A003',
        modifyTime: dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss'),
      }),
    );
    return {
      total: lodash.get(response, 'total'),
      dataSource: lodash.get(response, 'data'),
    };
  };

  /**
   * 值存储
   * @memberof CertController
   */
  Model = new BaseModel({ type: 'object', storageKey: 'cert' });

  /**
   * @dec 是否是空数据
   */
  @computed
  get isEmptyData(): Boolean {
    return lodash.eq(this.dataSource.length, 0) && this.Pagination.finished;
  }
  /**
   * @dec 搜索框是否有值
   */
  @computed
  get isEmptyNTitle(): Boolean {
    return lodash.isEmpty(lodash.get(this.Pagination, 'request.body.certName'));
  }
  /**
   * @dec tab是否处于产品资质状态
   */
  @computed
  get isCertActive(): Boolean {
    return lodash.eq(
      lodash.get(this.Pagination, 'request.body.nsectiononeId'),
      'A003',
    );
  }
  /**
   * @dec 是否展示反馈入口
   */
  @computed
  get isShowFeedback(): Boolean {
    return this.isEmptyData && !this.isEmptyNTitle && this.isCertActive;
  }

  /**
   * 提交反馈
   * @param
   * @returns
   */
  onFeedbackSubmit(body, address) {
    body = lodash.assign(body, {
      content: lodash.trim(body.content),
      provinceName: lodash.get(address, '[0].label'),
      provinceCode: lodash.get(address, '[0].value'),
      cityName: lodash.get(address, '[1].label'),
      cityCode: lodash.get(address, '[1].value'),
    });
    return AjaxBasics.request({ ...EnumAPI.cert_feekback_save, body });
  }

  /**
   *  证书列表
   */
  getCertList(body) {
    return AjaxBasics.request({
      ...EnumAPI.cert_list,
      body,
    });
  }

  /**
   *  证书下拉列表
   */
  getCertSelectList(body) {
    return AjaxBasics.request({
      ...EnumAPI.cert_select_list,
      body,
    });
  }

  /**
   *  证书地址获取
   */
  getCertUrl(body) {
    return AjaxBasics.request({
      ...EnumAPI.cert_file_url,
      body,
    });
  }

  /**
   *  证书预览次数获取
   */
  getPreviewTimes() {
    return AjaxBasics.request({
      ...EnumAPI.cert_preview_times,
    });
  }

  /**
   * 预览校验
   * @param dataSource
   * @param userInfo
   */
  async onPreviewVerify(dataSource, userInfo) {
    const message =
      '成为合作注册经销商享8000积分奖励,更多注册经销商福利，赶快注册领取!';
    if (!lodash.includes(['pdf', '图片'], dataSource.fileType)) {
      throw {
        error: 1,
        message: '此文件类型暂不支持预览',
      };
    }
    if (!lodash.get(userInfo, 'Auth.AccessToken')) {
      // 游客
      throw { error: 2, message };
    }
    // isg不做限制
    if (userInfo.isLevel2 && !userInfo.isISG && !userInfo.isL2) {
      // level2
      const res: any = await this.getPreviewTimes();
      if (res == null) return;
      const isOverTimes = lodash.eq(res, -1);
      if (isOverTimes) {
        if (userInfo.isAttestation) {
          throw { error: 3, message };
        } else {
          throw { error: 4, message };
        }
      } else {
        throw {
          error: 5,
          message: '您的可用浏览次数剩余' + res + '次',
        };
      }
    }
  }
  /**
   * 定位信息
   */
  @computed
  get address(): any {
    return lodash.get(this.Model.value, 'address');
  }

  /**
   *  证书发送邮箱下载
   */
  onSendEmail(body, userInfo, address?) {
    if (!lodash.isEmpty(address)) {
      this.Model.merge({ address });
    }
    // body = lodash.assign(body, {
    //     cityCode: lodash.get(userInfo, 'userExtendDTO.cityCode') || lodash.get(this.address, '[1].value'),
    //     cityName: lodash.get(userInfo, 'userExtendDTO.cityName') || lodash.get(this.address, '[1].label'),
    //     provinceCode: lodash.get(userInfo, 'userExtendDTO.provinceCode') || lodash.get(this.address, '[0].value'),
    //     provinceName: lodash.get(userInfo, 'userExtendDTO.province') || lodash.get(this.address, '[0].label'),
    //     salesName: lodash.get(userInfo, 'salesInfo.salesName'),
    //     salesPhone: lodash.get(userInfo, 'salesInfo.salesTelphone'),
    //     salesEmail: lodash.get(userInfo, 'salesInfo.salesEmail'),
    //     userEmail: lodash.get(userInfo, 'value.email')
    // })
    return AjaxBasics.request({
      ...EnumAPI.cert_send_email,
      body,
    });
  }

  /**
   * 下载校验
   * @param dataSource
   * @param userInfo
   */
  async onDownloadVerify(dataSource, userInfo) {
    if (!userInfo.isL2) {
      if (lodash.eq(Number(lodash.get(dataSource, 'isOverdue')), 1)) {
        throw { error: 1, message: '该资质文档已过期 请您使用有效版本' };
      }
    }
    // isg、con不做弹框提示，直接发送邮件(9：用户有邮箱直接发，10：无邮箱弹框输入邮箱点击确认发送)
    if (userInfo.isISG || userInfo.isL2 || userInfo.isCON) {
      if (userInfo.value.email) {
        throw { error: 9 };
      } else {
        throw { error: 10 };
      }
    }
    const message = `成为合作注册经销商享8000积分奖励,更多注册经销商福利，赶快注册领取!`;
    if (!lodash.get(userInfo, 'Auth.AccessToken')) {
      // 游客
      throw { error: 2, message };
    }
    // smb 且未通过企业OCR认证和人工审核
    if (userInfo.isSMB) {
      const res: any = await this.getCompanyStatusInfo();
      if (!res.manualReviewStatus && !res.ocrCheckStatus) {
        throw { error: 11 };
      }
      if (res.manualReviewStatus && !userInfo.isManualReviewAttestation) {
        throw { error: 11, message: 'update' };
      }
    }

    if (userInfo.isLevel2) {
      // level2
      if (userInfo.isAttestation) {
        throw { error: 3, message };
      } else {
        throw { error: 4, message };
      }
    }
    if (userInfo.isLevel3 || userInfo.isLevel4) {
      // level3\4
      const stel = lodash.get(userInfo, 'salesInfo.salesTelphone');
      const semail = lodash.get(userInfo, 'salesInfo.salesEmail');
      const cancat = stel ? `座机${stel}` : `邮箱${semail}`;
      const msg = `尊敬的${
        userInfo.isLevel3 ? '注册' : '签约'
      }经销商${lodash.get(userInfo, 'channelId')}，${lodash.get(
        userInfo,
        'value.realName',
      )}您好！您下载的资质证书需联系专属顾问${lodash.get(
        userInfo,
        'salesInfo.salesName',
      )}${cancat}盖章才能生效使用。未经生效用于商业用途将被追究法律责任`;
      if (userInfo.value.email) {
        throw { error: 5, message: msg };
      } else {
        throw { error: 6, message: msg };
      }
    }
    if (userInfo.isSales) {
      if (userInfo.value.email) {
        throw {
          error: 7,
          message: `${
            userInfo.userName
          }您好，您下载的资质证书已发送到您的工作邮箱${lodash.get(
            userInfo,
            'value.email',
          )}，下载行为已被系统记录，请按照公司规范使用`,
        };
      } else {
        throw {
          error: 8,
          message: '请联系内部人员添加邮箱',
        };
      }
    }
  }

  /**
   *  证书保存邮箱
   */
  onSaveEmail(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_update_userinfo,
      body,
    });
  }

  /**
   *  证书下载
   */
  onDownload(body) {
    return AjaxBasics.request({
      ...EnumAPI.cert_download,
      body,
    });
  }

  /** 获取企业认证信息 */
  async getCompanyStatusInfo() {
    try {
      return await AjaxBasics.request(EnumAPI.company_auth_authentication);
    } catch (error) {}
  }
}
